export default __webpack_public_path__ + "static/media/course_thumbnail.e80c3c36.png";